<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
  	<div class="tit">
  		<h1>Chegamos ao fim!</h1>
  		<p>Você ainda pode voltar nos passos anteriores se precisar rever ou alterar algo.</p>
  	</div>
    <div class="text-center fixedOptions">
			<button class="btn btn-lg btn-primary" @click="onSubmit">Concluir</button>
		</div>
  </div>
</template>

<script>
	export default {
	
		props: {
			solicitacao: {required: true, type: Object}
		},
		methods: {
			onSubmit(e) {
				e.preventDefault()

				const newData = {
						StatusAguarde: "25%", 
						AprovadoCliente: false,
						NegadoCliente: false
				}

		

				this.$emit('on-submit', newData)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/ConfirmacaoEnvioPasso.vue